import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

// 🌍 Liste enrichie de destinations avec images Unsplash fiables
const coordinatesList = [
  {
    rect: "-10.0,4.0,-2.0,11.0",
    country: "Côte d'Ivoire",
    code: "CI",
    continent: "Afrique",
    capital: "Yamoussoukro",
    population: "26 M",
    currency: "Franc CFA",
    language: "Français",
    image: "https://images.unsplash.com/photo-1523805009345-7448845a9e53?w=600&q=80",
    flag: "https://flagcdn.com/w40/ci.png"
  },
  {
    rect: "-74.0,40.0,-73.0,41.0",
    country: "États-Unis",
    code: "US",
    continent: "Amérique",
    capital: "Washington D.C.",
    population: "331 M",
    currency: "Dollar US",
    language: "Anglais",
    image: "https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=600&q=80",
    flag: "https://flagcdn.com/w40/us.png"
  },
  {
    rect: "2.0,48.0,3.0,49.0",
    country: "France",
    code: "FR",
    continent: "Europe",
    capital: "Paris",
    population: "67 M",
    currency: "Euro",
    language: "Français",
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&q=80",
    flag: "https://flagcdn.com/w40/fr.png"
  },
  {
    rect: "100.0,-10.0,101.0,-9.0",
    country: "Indonésie",
    code: "ID",
    continent: "Asie",
    capital: "Jakarta",
    population: "273 M",
    currency: "Roupie indonésienne",
    language: "Indonésien",
    image: "https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=600&q=80",
    flag: "https://flagcdn.com/w40/id.png"
  },
  {
    rect: "139.0,35.0,140.0,36.0",
    country: "Japon",
    code: "JP",
    continent: "Asie",
    capital: "Tokyo",
    population: "125 M",
    currency: "Yen",
    language: "Japonais",
    image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=600&q=80",
    flag: "https://flagcdn.com/w40/jp.png"
  },
  {
    rect: "12.0,41.0,13.0,42.0",
    country: "Italie",
    code: "IT",
    continent: "Europe",
    capital: "Rome",
    population: "59 M",
    currency: "Euro",
    language: "Italien",
    image: "https://images.unsplash.com/photo-1534445867742-43195f401b6c?w=600&q=80",
    flag: "https://flagcdn.com/w40/it.png"
  },
  {
    rect: "-3.8,40.3,-3.6,40.5",
    country: "Espagne",
    code: "ES",
    continent: "Europe",
    capital: "Madrid",
    population: "47 M",
    currency: "Euro",
    language: "Espagnol",
    image: "https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=600&q=80",
    flag: "https://flagcdn.com/w40/es.png"
  },
  {
    rect: "151.0,-34.0,152.0,-33.0",
    country: "Australie",
    code: "AU",
    continent: "Océanie",
    capital: "Canberra",
    population: "26 M",
    currency: "Dollar australien",
    language: "Anglais",
    image: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=600&q=80",
    flag: "https://flagcdn.com/w40/au.png"
  },
  {
    rect: "-58.5,-34.7,-58.3,-34.5",
    country: "Argentine",
    code: "AR",
    continent: "Amérique",
    capital: "Buenos Aires",
    population: "45 M",
    currency: "Peso argentin",
    language: "Espagnol",
    image: "https://images.unsplash.com/photo-1589909202802-8f4aadce1849?w=600&q=80",
    flag: "https://flagcdn.com/w40/ar.png"
  },
  {
    rect: "37.5,-1.3,37.7,-1.1",
    country: "Kenya",
    code: "KE",
    continent: "Afrique",
    capital: "Nairobi",
    population: "53 M",
    currency: "Shilling kényan",
    language: "Swahili, Anglais",
    image: "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=600&q=80",
    flag: "https://flagcdn.com/w40/ke.png"
  },
  {
    rect: "31.2,30.0,31.4,30.2",
    country: "Égypte",
    code: "EG",
    continent: "Afrique",
    capital: "Le Caire",
    population: "104 M",
    currency: "Livre égyptienne",
    language: "Arabe",
    image: "https://images.unsplash.com/photo-1539650116574-8efeb43e2750?w=600&q=80",
    flag: "https://flagcdn.com/w40/eg.png"
  },
  {
    rect: "55.2,25.1,55.4,25.3",
    country: "Émirats Arabes Unis",
    code: "AE",
    continent: "Asie",
    capital: "Abou Dabi",
    population: "9.9 M",
    currency: "Dirham",
    language: "Arabe",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&q=80",
    flag: "https://flagcdn.com/w40/ae.png"
  },
  {
    rect: "-46.7,-23.7,-46.5,-23.5",
    country: "Brésil",
    code: "BR",
    continent: "Amérique",
    capital: "Brasília",
    population: "213 M",
    currency: "Réal brésilien",
    language: "Portugais",
    image: "https://images.unsplash.com/photo-1516306585401-c7e4f8a1c3e0?w=600&q=80",
    flag: "https://flagcdn.com/w40/br.png"
  },
  {
    rect: "28.6,77.1,28.7,77.3",
    country: "Inde",
    code: "IN",
    continent: "Asie",
    capital: "New Delhi",
    population: "1,4 Md",
    currency: "Roupie indienne",
    language: "Hindi, Anglais",
    image: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=600&q=80",
    flag: "https://flagcdn.com/w40/in.png"
  },
  {
    rect: "30.0,59.9,30.4,60.1",
    country: "Russie",
    code: "RU",
    continent: "Europe/Asie",
    capital: "Moscou",
    population: "144 M",
    currency: "Rouble",
    language: "Russe",
    image: "https://images.unsplash.com/photo-1513326738677-b964603b136d?w=600&q=80",
    flag: "https://flagcdn.com/w40/ru.png"
  },
  {
    rect: "-79.4,43.7,-79.3,43.8",
    country: "Canada",
    code: "CA",
    continent: "Amérique",
    capital: "Ottawa",
    population: "38 M",
    currency: "Dollar canadien",
    language: "Anglais, Français",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=80",
    flag: "https://flagcdn.com/w40/ca.png"
  },
  {
    rect: "31.0,-30.0,32.0,-29.0",
    country: "Afrique du Sud",
    code: "ZA",
    continent: "Afrique",
    capital: "Pretoria",
    population: "60 M",
    currency: "Rand",
    language: "11 langues officielles",
    image: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=600&q=80",
    flag: "https://flagcdn.com/w40/za.png"
  },
  {
    rect: "2.0,6.0,3.0,7.0",
    country: "Bénin",
    code: "BJ",
    continent: "Afrique",
    capital: "Porto-Novo",
    population: "12 M",
    currency: "Franc CFA",
    language: "Français",
    image: "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=600&q=80",
    flag: "https://flagcdn.com/w40/bj.png"
  },
  {
    rect: "-1.0,5.0,0.0,6.0",
    country: "Ghana",
    code: "GH",
    continent: "Afrique",
    capital: "Accra",
    population: "31 M",
    currency: "Cedi",
    language: "Anglais",
    image: "https://images.unsplash.com/photo-1570087934085-c2e95b8d1b5e?w=600&q=80",
    flag: "https://flagcdn.com/w40/gh.png"
  },
  {
    rect: "-17.0,14.0,-16.0,15.0",
    country: "Sénégal",
    code: "SN",
    continent: "Afrique",
    capital: "Dakar",
    population: "17 M",
    currency: "Franc CFA",
    language: "Français",
    image: "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=600&q=80",
    flag: "https://flagcdn.com/w40/sn.png"
  },
  {
    rect: "6.0,9.0,7.0,10.0",
    country: "Nigeria",
    code: "NG",
    continent: "Afrique",
    capital: "Abuja",
    population: "206 M",
    currency: "Naira",
    language: "Anglais",
    image: "https://images.unsplash.com/photo-1569025743873-ea3a9ade89f9?w=600&q=80",
    flag: "https://flagcdn.com/w40/ng.png"
  },
  {
    rect: "113.0,22.0,114.0,23.0",
    country: "Chine",
    code: "CN",
    continent: "Asie",
    capital: "Pékin",
    population: "1,4 Md",
    currency: "Yuan",
    language: "Chinois",
    image: "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=600&q=80",
    flag: "https://flagcdn.com/w40/cn.png"
  },
  {
    rect: "126.0,37.0,127.0,38.0",
    country: "Corée du Sud",
    code: "KR",
    continent: "Asie",
    capital: "Séoul",
    population: "51 M",
    currency: "Won",
    language: "Coréen",
    image: "https://images.unsplash.com/photo-1534274988757-a28bf1a57c17?w=600&q=80",
    flag: "https://flagcdn.com/w40/kr.png"
  },
  {
    rect: "100.0,13.0,101.0,14.0",
    country: "Thaïlande",
    code: "TH",
    continent: "Asie",
    capital: "Bangkok",
    population: "70 M",
    currency: "Baht",
    language: "Thaï",
    image: "https://images.unsplash.com/photo-1504214208698-ea1916a2195a?w=600&q=80",
    flag: "https://flagcdn.com/w40/th.png"
  },
  {
    rect: "103.0,1.0,104.0,2.0",
    country: "Singapour",
    code: "SG",
    continent: "Asie",
    capital: "Singapour",
    population: "5,7 M",
    currency: "Dollar de Singapour",
    language: "Anglais, Malais, Chinois",
    image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=600&q=80",
    flag: "https://flagcdn.com/w40/sg.png"
  },
  {
    rect: "-3.0,56.0,-2.0,57.0",
    country: "Royaume-Uni",
    code: "GB",
    continent: "Europe",
    capital: "Londres",
    population: "67 M",
    currency: "Livre sterling",
    language: "Anglais",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&q=80",
    flag: "https://flagcdn.com/w40/gb.png"
  },
  {
    rect: "13.0,52.0,14.0,53.0",
    country: "Allemagne",
    code: "DE",
    continent: "Europe",
    capital: "Berlin",
    population: "83 M",
    currency: "Euro",
    language: "Allemand",
    image: "https://images.unsplash.com/photo-1559941727-6fb1eced0e5c?w=600&q=80",
    flag: "https://flagcdn.com/w40/de.png"
  },
  {
    rect: "4.0,52.0,5.0,53.0",
    country: "Pays-Bas",
    code: "NL",
    continent: "Europe",
    capital: "Amsterdam",
    population: "17 M",
    currency: "Euro",
    language: "Néerlandais",
    image: "https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=600&q=80",
    flag: "https://flagcdn.com/w40/nl.png"
  },
  {
    rect: "-8.0,39.0,-7.0,40.0",
    country: "Portugal",
    code: "PT",
    continent: "Europe",
    capital: "Lisbonne",
    population: "10 M",
    currency: "Euro",
    language: "Portugais",
    image: "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=600&q=80",
    flag: "https://flagcdn.com/w40/pt.png"
  },
];

export default function PopularDestinations() {
  const [places, setPlaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reloading, setReloading] = useState(false);

  // Fallback : destinations locales utilisées quand l'API échoue
  const getFallbackDestinations = () => {
    const shuffled = [...coordinatesList].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 6);
  };

  // Charger les lieux (mode API ou fallback local)
  const fetchPlaces = async () => {
    setReloading(true);
    const randomIndex = Math.floor(Math.random() * coordinatesList.length);
    const selected = coordinatesList[randomIndex];
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/external_apis/proxy.php?type=geoapify&categories=tourism.attraction&rect=${selected.rect}&limit=6`
      );

      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        // Fallback local direct
        setPlaces(getFallbackDestinations());
        return;
      }

      if (!res.ok) throw new Error(`Erreur HTTP : ${res.status}`);
      const data = await res.json();

      if (data.error || !data.features?.length) {
        setPlaces(getFallbackDestinations());
        return;
      }

      const apiPlaces = data.features?.map((p) => ({ ...p, countryInfo: selected })) || [];
      if (apiPlaces.length === 0) {
        setPlaces(getFallbackDestinations());
      } else {
        setPlaces(apiPlaces);
      }
    } catch (error) {
      console.warn("⚠️ API non accessible, utilisation des destinations locales:", error.message);
      setPlaces(getFallbackDestinations());
    } finally {
      setLoading(false);
      setTimeout(() => setReloading(false), 1000);
    }
  };

  useEffect(() => {
    fetchPlaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <section className="py-20 bg-gradient-to-b from-blue-50 via-white to-yellow-50">
        <h2 className="text-5xl font-extrabold text-center mb-6 text-blue-800 drop-shadow-lg">
          🌍 Évasions populaires
        </h2>
        <p className="text-center text-gray-500 animate-pulse text-xl">
          ✨ Préparez vos valises... chargement en cours
        </p>
      </section>
    );
  }

  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 via-white to-yellow-50">
      <h2 className="text-5xl font-extrabold text-center mb-6 text-blue-800 drop-shadow-lg">
        🌍 Évasions populaires
      </h2>
      <p className="text-center text-lg text-gray-600 mb-14">
        Découvrez des lieux magiques autour du monde et laissez-vous inspirer 🌴
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 container mx-auto px-6">
        {places.map((place, index) => {
          // Support à la fois le mode API (avec countryInfo) et le mode fallback (direct)
          const countryInfo = place.countryInfo || place;
          const name = place.properties?.name || countryInfo.capital || "Destination";
          const city = place.properties?.city || place.properties?.county || countryInfo.capital || "Lieu connu";
          const category = place.properties?.categories?.[0] || "Destination populaire";
          const imageUrl = countryInfo.image;
          const flagUrl = countryInfo.flag;

          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition transform hover:-translate-y-2 hover:scale-105 group"
            >
              {/* Image avec fallback couleur */}
              <div className="relative h-56 overflow-hidden bg-gradient-to-br from-blue-100 to-blue-200">
                <img
                  src={imageUrl}
                  alt={name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    // Affiche le fallback coloré avec les initiales
                    const fallback = e.target.nextSibling;
                    if (fallback) fallback.style.display = 'flex';
                  }}
                />
                <div className="hidden absolute inset-0 items-center justify-center text-6xl font-black text-blue-300/50">
                  {countryInfo.code}
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-2xl font-bold text-blue-700 mb-2">{name}</h3>
                <p className="text-gray-600 flex items-center gap-2 text-lg">
                  📍 {city}
                </p>

                {countryInfo && (
                  <div className="mt-3 text-sm text-gray-700 space-y-1">
                    <p className="flex items-center gap-2">
                      <img
                        src={flagUrl}
                        alt={countryInfo.country}
                        className="w-6 h-4 rounded shadow"
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                      <span className="font-medium">{countryInfo.country}</span>
                    </p>
                    <p>🌍 Continent : {countryInfo.continent}</p>
                    <p>🏙 Capitale : {countryInfo.capital}</p>
                    <p>👥 Population : {countryInfo.population}</p>
                    <p>💰 Monnaie : {countryInfo.currency}</p>
                    <p>🗣 Langue : {countryInfo.language}</p>
                  </div>
                )}

                <span className="mt-4 inline-block bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-5 py-2 rounded-full text-sm font-medium shadow-md">
                  {category}
                </span>
              </div>
            </motion.div>
          );
        })}
      </div>

      <div className="text-center mt-10">
        <button
          onClick={fetchPlaces}
          className={`inline-flex items-center justify-center px-6 py-2 text-white font-semibold rounded-lg transition-all duration-300 ${
            reloading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-700"
          }`}
          disabled={reloading}
        >
          {reloading ? (
            <svg className="w-5 h-5 animate-spin mr-2" viewBox="0 0 24 24" fill="none">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 1116 0A8 8 0 014 12z" />
            </svg>
          ) : (
            "Charger d'autres destinations"
          )}
        </button>
      </div>
    </section>
  );
}